const formItems = $('.powermail_fieldwrap input');

formItems.change(function (e) {
  if (e.target.value) {
    $(this).addClass('valid');
  } else {
    $(this).removeClass('valid');
  }
});
